import React from 'react';
import { SVGIconProps } from '../../domains/common';

const DV360Icon: React.FC<SVGIconProps> = ({ colored, ...rest }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="4 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M22.9421 13.3833C24.5018 12.5282 26.5332 12.977 27.4788 14.3856C28.4256 15.7942 27.9287 17.6288 26.369 18.4828C26.3274 18.5056 26.2858 18.5273 26.2442 18.5481L9.03741 27.4968C7.47774 28.3518 5.44633 27.903 4.49957 26.4944C3.55282 25.0859 4.04973 23.2512 5.60941 22.3962C5.651 22.3735 5.69259 22.3517 5.73418 22.331L22.9421 13.3833Z"
        fill={colored ? '#81C995' : '#365284'}
      />
      <path
        d="M10.5783 7.00165C10.586 5.35781 9.11607 4.01843 7.2959 4.01151C7.06167 4.01052 6.82854 4.03226 6.5987 4.07576C5.05653 4.41777 3.97844 5.67512 4.00033 7.11039V24.8842L10.5718 24.992L10.5783 7.00165Z"
        fill={colored ? '#34A853' : '#365284'}
      />
      <path
        d="M23.0163 18.559C24.6066 19.3033 26.5636 18.8269 27.5245 17.4608C28.4483 16.0572 27.9372 14.2423 26.383 13.4081C26.3709 13.4021 26.36 13.3962 26.3479 13.3893L9.02622 4.42477C7.48406 3.58358 5.47782 4.03037 4.5453 5.42314C4.52231 5.45773 4.49933 5.49332 4.47744 5.5289C3.56243 6.94341 4.08998 8.76123 5.65622 9.58858C5.66717 9.59451 5.67811 9.59945 5.68906 9.60538L23.0163 18.559Z"
        fill={colored ? '#5BB974' : '#3F5B8D'}
      />
      <path
        d="M26.2341 18.5797L10.5728 26.4806V19.6937L22.9998 13.4357C24.6471 12.6113 26.7233 13.149 27.6362 14.6376C27.7215 14.776 27.7938 14.9204 27.854 15.0686C28.3202 16.4377 27.6395 17.9135 26.2341 18.5797Z"
        fill={colored ? '#81C995' : '#4B6799'}
      />
      <path
        d="M7.29256 27.9999C9.10721 27.9999 10.5783 26.6713 10.5783 25.0325C10.5783 23.3936 9.10721 22.0651 7.29256 22.0651C5.4779 22.0651 4.00684 23.3936 4.00684 25.0325C4.00684 26.6713 5.4779 27.9999 7.29256 27.9999Z"
        fill={colored ? '#1E8E3E' : '#37536D'}
      />
    </svg>
  );
};

export default DV360Icon;
